/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert-button-icon[_ngcontent-%COMP%]{font-size:1rem}.notification-icon[_ngcontent-%COMP%]{height:3rem;width:3rem;border:.2rem solid #ccc;border-radius:50%}.alert-button[_ngcontent-%COMP%]{height:3rem;max-width:12rem;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center}.alert-button[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding-left:.5rem;color:#fff;font-weight:700}"];
export { styles as styles };
